import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useIsEmployee } from '@hooks/use-is-employee.ts';

const InternalRoute = () => {
  const isAuthenticated = useIsAuthenticated();
  const isEmployee = useIsEmployee();

  return isAuthenticated && isEmployee ? <Outlet /> : <Navigate to="/auth" />;
};

export default InternalRoute;
